/**
 * @packageDocumentation
 * @module Boorus
 */

import Booru from './Booru'

/**
 * A class designed for Xml-returning boorus
 *
 * @extends Booru
 * @inheritDoc
 */
export default class XmlBooru extends Booru {}
